import React from 'react'
import AlertStaticBox from './worten/alert-static-box'
import { MdNotInterested } from "react-icons/md";
import { Box } from '@mui/system';

export const NotAuthorized = ({role}) => {
  return (
    <Box p={5}>
      <AlertStaticBox
        icon= {<MdNotInterested />}
        title= "Usuario no autorizado"
        sx= {{}}
        iconColor='red'
      >
      Tu usuario [{role}] no tiene permisos para acceder a esta sección.
      </AlertStaticBox>
    </Box>
  )
}
